import { store } from '@betacrew/jars-flux'
import { put, takeEvery, all, call, takeLatest } from 'redux-saga/effects';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { COMMON_LOADING_STATES, PAGE_STATE } from '../../constants/constants';
import PayerDataService from '../../../../services/PayerDataService';
import { componentKey, setExportFile, setForm, setHistory, setLoadingState, setPayersList, setTaxYear, setTotalHistory} from './StateFilingHistorySlice';
import ManageFormsService from '../../../../services/ManageFormsService';
import HistoryDataService from '../../../../services/HistoryDataService';
import Payer from '../../../../libs/utility/Payer';
import GeneralDataService from '../../../../services/GeneralDataService';
import General from '../../../../libs/utility/General';

export const { getPayerList, getStateFilingHistory, getTaxYearsList, getFormsList } = {
    getPayerList: (payload) => {
        return {
            type: "STATEFILING/GET_PAYERS",
            payload: payload
        }
    },
    getStateFilingHistory: (payload) => {
        return {
            type: "STATEFILING/GET_STATE_FILING_HISTORY",
            payload: payload
        }
    },
    getTaxYearsList: (payload) => {
        return {
            type: "STATEFILING/GET_TAX_YEARS_LIST",
            payload: payload
        }
    },
    getFormsList: (payload) => {
        return {
            type: "STATEFILING/GET_FORMS_LIST",
            payload: payload
        }
    },
}

function* getPayerListAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_LOADING, message: "Getting Payers......" }));
        const response = yield ManageFormsService.getFederalPayers();
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setPayersList(response.data.Data.map(payer => ({label: payer.LastName, value: payer.PayerDetailId}))));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_READY }))
    }
}

function* getStateFilingHistoryAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_LOADING, message: "Getting Filing History......" }));
        const response = yield HistoryDataService.GetStateSubmissionDetails(action.payload);
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setHistory([...General.extractDataFromResponseData(response.data)]));
            yield put(setTotalHistory(General.extractPaginationTotalFromResponse(response.data)));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_READY }))
    }
}

function* getTaxYearsListAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_LOADING, message: "Getting Tax Years......" }));
        const response = yield GeneralDataService.getTaxYears();
        if (response?.data?.Status && response.data.Status === 1) {
            
            yield put(setTaxYear(response.data.Data.map(year => ({label: year.ID, value: year.ID}) )));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_READY }))
    }
}

function* getFormsListAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_LOADING, message: "Getting Forms......" }));
        const response = yield ManageFormsService.getStateForms();
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setForm(response.data.Data.map(form => ({label: form.FormName1, value: form.FormId}) )));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getPayerList().type, getPayerListAsync),
        takeLatest(getStateFilingHistory().type, getStateFilingHistoryAsync),
        takeLatest(getTaxYearsList().type, getTaxYearsListAsync),
        takeLatest(getFormsList().type, getFormsListAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);